import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import EmailTemplateFormContainer from './EmailTemplateFormContainer';

const EmailTemplateFormScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Email Templates',
          link: '/email-templates',
        },
        {
          text: props.params.emailTemplateId ? 'Edit Email Template' : 'Add Email Template',
        },
      ]}
    />
    <Card
      title={props.params.emailTemplateId ? 'Edit Email Template' : 'Add Email Template'}
      actions={<Button type="default" icon="arrow-left" label="Back" onClick={() => browserHistory.goBack()} />}
    >
      <EmailTemplateFormContainer emailTemplateId={props.params.emailTemplateId} />
    </Card>
  </div>
);

EmailTemplateFormScene.propTypes = {
  params: PropTypes.shape({
    emailTemplateId: PropTypes.string,
  }),
};

EmailTemplateFormScene.defaultProps = {
  params: null,
};

export default EmailTemplateFormScene;
